export default {"src":"/_next/static/media/ethIcon.6a7ad42f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};